//Actions
import {
  SET_BRANDING_ASSETS_DATA,
  SET_BRANDING_ASSETS_LOADER,
  CREATE_BRANDING_ASSET,
  UPDATE_BRANDING_ASSET,
  DELETE_BRANDING_ASSET,
  LOGOUT,
} from '~/redux/actions/action-types';

const initialState = {
  brandingAssets: [],
  rowsCount: 0,
  to: null,
  from: null,
  lastPage: null,
  currentPage: null,
  perPage: 20,
  totalBrandingAssetsInDB: null,
  loading: false,
  selectedBrandingAsset: null,
};

const brandingAssetsReducers = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_BRANDING_ASSETS_DATA:
      return {
        ...state,
        brandingAssets: payload.rows || payload.data || [],
        rowsCount: payload.count || payload.rows?.length || 0,
        totalBrandingAssetsInDB: payload.totalRecordsInDB || payload.total || 0,
        to: payload.to || null,
        from: payload.from || null,
        lastPage: payload.lastPage || null,
        currentPage: payload.currentPage || 1,
        perPage: payload.perPage || 20,
      };
    case SET_BRANDING_ASSETS_LOADER:
      return { ...state, loading: payload };
    case CREATE_BRANDING_ASSET:
      return {
        ...state,
        brandingAssets: [payload, ...state.brandingAssets],
        rowsCount: state.rowsCount + 1,
        totalBrandingAssetsInDB: state.totalBrandingAssetsInDB + 1,
      };
    case UPDATE_BRANDING_ASSET:
      return {
        ...state,
        brandingAssets: state.brandingAssets.map((asset) =>
          asset.id === payload.id ? { ...asset, ...payload.data } : asset
        ),
      };
    case DELETE_BRANDING_ASSET:
      return {
        ...state,
        brandingAssets: state.brandingAssets.filter((asset) => asset.id !== payload),
        rowsCount: state.rowsCount - 1,
        totalBrandingAssetsInDB: state.totalBrandingAssetsInDB - 1,
      };
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export { brandingAssetsReducers };
